import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface LocationPermissionAlertData {
  title?: string;
  message: string;
  actionText?: string;
  icon?: string;
  iconBackground?: string;
  iconColor?: string;
}

@Component({
  selector: 'app-location-permission-alert',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './location-permission-alert.component.html',
})
export class LocationPermissionAlertComponent {
  constructor(
    public dialogRef: MatDialogRef<LocationPermissionAlertComponent, void>,
    @Inject(MAT_DIALOG_DATA) public data: LocationPermissionAlertData,
  ) {}

  public close(): void {
    this.dialogRef.close();
  }
}
